import {
  getRatings,
  getTotalComponentByIdAndKeywords,
  logout,
  postDisLike,
  postLike
} from "api/interna-api";
import Button from "components/atoms/Button";
import Heading from "components/atoms/Heading";
import Icon from "components/atoms/Icon";
import Image from "components/atoms/Image";
import LoadingState from "components/atoms/LoadingState";
import Tag from "components/atoms/Tag";
import Text from "components/atoms/Text";
import UIPlaceholder from "components/atoms/UIPlaceholder";
import Layout from "components/layout";
import Article from "components/molecules/Article";
import Breadcrumb, { BreadcrumbItem, BreadcrumbItemLink } from "components/molecules/Breadcrumb";
import Carousel from "components/molecules/Carousel";
import CarouselItem from "components/molecules/Carousel/CarouselItem";
import CompareBlock from "components/molecules/CompareBlock";
import Head from "components/molecules/Head";
import InfoBuyingForm from "components/molecules/InfoBuyingForm";
import LoadingBox from "components/molecules/LoadingBox";
import Player from "components/molecules/player";
import Product from "components/molecules/Product";
import ProductCarousel from "components/molecules/Productcarousel";
import Productfeature from "components/molecules/Productfeature";
import RatingCommentForm from "components/molecules/RatingCommentForm";
import Rcrating from "components/molecules/rcrating";
import ReviewProductForm from "components/molecules/ReviewProductForm";
import { TabPanel, Tabs } from "components/molecules/Tabs";
import Grid, { GridCol, GridRow } from "components/organisms/Grid";
import Modal from "components/organisms/Modal";
import ModalBody from "components/organisms/Modal/Body";
import ModalFooter from "components/organisms/Modal/Footer";
import ModalHeader from "components/organisms/Modal/Header";
import ProductInfomation from "components/organisms/ProductInfomation";
import ScrollTabProductDetail from "components/organisms/ScrollTabProductDetail";
import Section from "components/organisms/Section";
import colors from "constants/colors";
import { BASE_URL, SITE_URL } from "constants/env";
import { SizeMin } from "constants/media";
import { initialNotify } from "constants/notify";
import { CAROUSEL_IDS, PRODUCT_DETAIL, SEEN_PRODUCT } from "constants/swiper";
import FsLightbox from "fslightbox-react";
import { useSelector } from "hooks/useApp";
import useCompare from "hooks/useCompare";
import useWindowSize from "hooks/useWindowSize";
import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactGA from "react-ga";
import LazyLoad from 'react-lazyload';
import { useDispatch } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { WithContext as ReactTags } from "react-tag-input";
import { authLogout } from "redux/actions/auth/auths";
import { requestFetchProductCities } from "redux/actions/general/productCities";
import { requestValidationAccount } from "redux/actions/general/validationAccount";
import { fetchCartProducts } from "redux/actions/products/cart";
import { requestFetchCriterias } from "redux/actions/products/criterias";
import {
  requestFetchDetailProduct,
  resetDetailProduct
} from "redux/actions/products/detail";
import { requestFetchSeenProducts } from "redux/actions/products/seen";
import { Navigation, SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';

import RedirectNavigate from 'components/common/redirect301';
import { joinClassnames } from "utils/map-modifier";
import {
  BROWSERS,
  getBrowser,
  getObject,
  getThisMachine,
  getTimeAgo,
  isAvailableObject,
  isVideo,
  notEmptyObject,
  scrollIntoRef,
  updateThisMachineVisitCount
} from "utils/utils-common";
import checkCircleOutlineBlue from "./../../../images/icons/check-blue.svg";
import checkCircleOutlineGreen from "./../../../images/icons/check-green.svg";
import heartBlue from "./../../../images/icons/heartBlue.svg";
import heartGray from "./../../../images/icons/heartGray.svg";
import deActiveStarIcon from "./../../../images/icons/star-light-gray.svg";
import activeStarIcon from "./../../../images/icons/star-orange.svg";
import "./index.scss";
import {
  ActionAndDatingBlock, ActiveStar, AnimateBox, ClientCommentReviewContent, ClientCommentReviewItem,
  ClientCommentReviewItemInner, ClientCommentReviews, ClientCommentReviewStatusBar, ClientCommentReviewTitle,
  ClientCommentReviewWrap, ClientCommentSearchBar, ClientUploadImageDetailItem, ClientUploadImageItem,
  ClientUploadImageList, ClientUploadImagePreviewItem, CommentBlock, ContentBlock, CriteriaBody, CriteriaContainer,
  CriteriaHeading, CustomerListReviewModal, CustomerReviewModal, DeActiveStar, GridHeading, GridReviewChatHeading,
  GridReviewChatTitle, InfiniteScrollExtendedOuter, InputReview, LeftCLientCommentReview, ListTagView, ListTagViewInner,
  ModalBodyInner, PaginationExtened, ProgressFill, ProgressLine, RatingBody, RatingContainer, RatingCounterLabel,
  RatingHeading, RatingImageSlider, RatingInformation, RatingInformationDetailModalTitle, RatingSection, RatingValue,
  RcRatingWrapper, ReplyDivider, ReplyDuration, ReplyLove, ReplyStatus, ReviewBody, ReviewContainer, ReviewGrid,
  ReviewHeading, ReviewItem, ReviewItemImg, ReviewItemImgWrapper, ReviewItemInner, ReviewItemRating, ReviewTitle,
  SearchBarButton, SearchBarWrapper, STab, TabList, TabListItem, TagReview, TagViews, TextExtended, UIProgress,
  UIProgressLine, UIProgressStatValue, UIProgressStatValueReview, UIProgressStatValueStat, UIReviewStat,
  UIReviewStatTitle, VerifyBuyAtDaikinEShop, VideoPanelPreviewItem, VideoPanelSearchItem
} from "./styled";


const ProductDetailPage: React.FC = () => {
  const dispatch = useDispatch();
  const { slug } = useParams<{
    slug: string;
  }>();
  const history = useHistory();
  const location = useLocation();

  // refs
  const ratingCountingLandRef = useRef<HTMLDivElement | null>(null);
  const productInfoRef = useRef(null);
  const productTabRef = useRef(null);
  const relatedProductRef = useRef(null);
  const ratingContainerRef = useRef<HTMLDivElement | null>(null);

  // selectors
  const { validationAccount } = useSelector(state => state.general);
  const { userInfor: userInformation } = useSelector(state => state);
  const { seen } = useSelector(state => state.products);
  const {
    compare: { data: compareList },
  } = useSelector(state => state.pages);
  const { detail, criterias } = useSelector(state => state.products);

  const { width } = useWindowSize();
  const {
    onCompare,
    goToCompare,
  } = useCompare(compareList);

  const [notify, setNotify] = useState<NotifyType>(initialNotify);

  const onCloseModal = () => {
    setNotify(initialNotify);
  };

  // LIKE/DISLIKE FEATURE:
  const LIKE_TYPE = {
    RATING: "rating",
    COMMENT: "comment",
  };
  // RATING DATA SEARCH:
  const delimiters = [188, 13];

  // state
  const [toggleInfoBuyingForm, setToggleInfoBuyingForm] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [seenList, setSeenList] = useState([]);
  const [
    limitLayoutRatingImagePreview,
    setLimitLayoutRatingImagePreview,
  ] = useState(2);
  const [avgRatingState, setAvgRatingState] = useState();
  const [listImagesRatingPreview, setListImagesRatingPreview] = useState([]);
  const [hasMoreRatings, setHasMoreRatings] = useState(false);
  const [ratingState, setRatingState] = useState();
  const [ratingItemsState, setRatingItemsState] = useState<any[]>();
  const [groupRatingState, setGroupRatingState] = useState<{
    [key: number]: {
      length: number;
      ratings: any;
      meta: any;
    };
  }>({});
  const [toggleCompare, setToggleCompare] = useState(false);
  const [heroNavPosition, setHeroNavPosition] = useState<number>();
  const [questionForClientLoading, setQuestionForClientLoading] = useState(
    true,
  );
  const [reviewModal, setReviewModal] = useState(false);
  const [listReviewModal, setListReviewModal] = useState(false);
  const [detailReviewModal, setDetailReviewModal] = useState<{
    status: boolean;
    data: any;
    liked?: boolean;
  }>();
  const [tags, setTags] = useState([]);
  const [loadingSearchRatings, setLoadingSearchRatings] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [currentSearchTabIndex, setCurrentSearchTabIndex] = useState(0);
  const [pageNumRatingStateSearch, setPageNumRatingStateSearch] = useState(0);
  const [loadingRating, setLoadingRating] = useState(false);
  const [pageNumRatingList, setPageNumRatingList] = useState(0);
  const [loadingListRatingPage, setLoadingListRatingPage] = useState(false);
  const [showCommentPopUp, setShowCommentPopUp] = useState<{
    ratingId: number;
    status: boolean;
  }>({
    ratingId: -1,
    status: false,
  });
  const [selectedReviewTab, setSelectedReviewTab] = useState(0);
  const [isLimitRatingProduct, setIsLimitRatingProduct] = useState(false);
  const [customerId, setCustomerId] = useState<string | undefined>();
  const [isShow, setIsShow] = useState<boolean>(false);
  const productIds = useMemo(
    () => window.localStorage.getItem("productIds"),
    [],
  );
  const [
    seenProductHasCashbackLabel,
    setSeenProductHasCashbackLabel,
  ] = useState(false);
  const [processingLikePostLoading, setProcessingLikePostLoading] = useState<{
    id: string | -1;
    onload: boolean;
  }>({ id: -1, onload: false });
  const [preventClosingModal, setPreventClosingModal] = useState(false);
  const [lightBoxRatingItemData, setLightBoxRatingItemData] = useState();
  const [lightBoxRatingItemTypes, setLightBoxRatingItemTypes] = useState();
  const [lightboxRatingItem, setLightboxRatingItem] = useState({
    toggler: false,
    activeSlide: 1,
  });
  const [dataLightBox, setDataLightbox] = useState<{
    togger: boolean;
    data: any;
    activeSlide: number;
  }>();
  const scrollTab = useMemo(
    () => document.getElementsByClassName("o-scroll-tab-hideheading"),
    [],
  );
  const [metaData, setMetaData] = useState<HeadData>();
  const { data: { step1, step2 }, loading: loadingDetail, error } = detail;

  useEffect(() => {
    if (step1) {
      setToggleCompare(
        compareList.find(c => c.id === step1.id) ? true : false,
      );
    }
  }, [compareList, step1]);

  const onSubmitInfoBuyingForm = (result: boolean) => {
    setToggleInfoBuyingForm(false);
    setNotify({
      ...notify,
      status: true,
      type: "",
      message: result
        ? "Chúng tôi sẽ liên hệ quý khách trong thời gian sớm nhất"
        : "Thông tin gửi lên bị lỗi",
      error: !result,
    });
  };

  const onSubmitReviewProductForm = (success: boolean) => {
    if (success) {
      setReviewModal(false);
    }
  };

  const onSubmitCommentForm = (success: boolean) => {
    if (success) {
      setShowCommentPopUp({
        ratingId: -1,
        status: false,
      });
    }
  };

  const saveSeenProduct = (id: string) => {
    const productIds = window.localStorage.getItem("productIds");
    if (productIds) {
      if (!productIds.split(",").includes(id)) {
        window.localStorage.setItem("productIds", productIds.concat(`,${id}`));
      }
    } else {
      window.localStorage.setItem("productIds", id);
    }
  };

  useEffect(() => {
    if (step1?.id) {
      saveSeenProduct(step1?.id?.toString());
      dispatch(requestFetchProductCities(step1?.id));
    }
  }, [dispatch, step1])

  const step12 = useMemo(() => step2 && ({
    ...(step1 ? step1 : {}),
    ...step2,
  }), [step1, step2])

  useEffect(() => {
    // call api lấy step1 data của api /info
    dispatch(requestFetchDetailProduct(slug, "step1"));
    const id = setTimeout(() => {
      // call api lấy step2 data của api /info
      dispatch(requestFetchDetailProduct(slug, "step2"));
      // call api lấy criterial
      dispatch(requestFetchCriterias());
    }, 2500);

    return () => {
      clearTimeout(id);
    }
  }, [dispatch, slug]);

  const getQuantity = (quantity: number) => {
    setQuantity(quantity);
  };

  const onToggleInfoBuyingForm = () => {
    setToggleInfoBuyingForm(true);
  };

  const gaData = useMemo(() => step1 && ({
    id: step1.model, // Transaction ID. Required.
    name: step1.name, // Product name. Required.
    sku: step1.model, // SKU/code.
    price: Number(step1.price), // Unit price.
    revenue: Number(step1.price), // Unit price.
    ...(step1.name_product_type
      ? { category: step1.name_product_type }
      : {}), // Category or variation.
    quantity: 1, // Quantity.
    list: "Product Detail View", // List name.
  }), [step1]);

  const gaTrackingViewingProductDetail = () => {
    // enhance ecommerce
    ReactGA.plugin.execute("ec", "addProduct", gaData);
    ReactGA.plugin.execute("ec", "setAction", "detail");
  };

  useEffect(() => {
    const { loading, data } = criterias;
    if (!loading && !!data?.length) {
      setQuestionForClientLoading(false);
    }
  }, [criterias]);

  const getTopPositionIfHasHeroCarousel = () => {
    const _hero = document.getElementsByClassName("m-herocarousel")[0];
    if (_hero) {
      setHeroNavPosition(_hero.clientHeight / 2);
    }
  };

  const handleRatingStateSearchRequestPage = ({ selected: page }) => {
    if (!isNaN(page)) {
      setPageNumRatingStateSearch(page + 1);
    }
  };

  const handleGetRating = (
    productId: number,
    page: number,
    keyWords?: string,
    numberRating?: number,
  ) => {
    setLoadingSearchRatings(true);
    getRatings(
      6,
      productId,
      page,
      keyWords,
      numberRating,
    )
      .then(data => {
        setSearchResults(data.data);
        setRatingState(data);
      })
      .catch(error => { })
      .finally(() => {
        setLoadingSearchRatings(false);
      });
  };

  useEffect(() => {
    !tags && setPageNumRatingStateSearch(0);
  }, [tags]);

  useEffect(() => {
    if (step1 && step1.id) {
      handleGetRating(
        step1.id,
        pageNumRatingStateSearch || 1,
        tags.map((item: any) => item.text).join(","),
        currentSearchTabIndex || 0,
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags, pageNumRatingStateSearch, currentSearchTabIndex]);

  const handleDelete = i => {
    setTags(tags.filter((tag, index) => index !== i));
  };

  const handleAddition = (tag: any) => {
    setTags([...tags, tag]);
  };

  const getFeatureDateByIncreaseMonthToday = (month: number) => {
    let date = new Date();
    return new Date(date.setMonth(date.getMonth() + month));
  };

  // Default Load Rating Data onload page:
  useEffect(() => {
    if (step1) {
      setTimeout(() => {
        setLoadingRating(true);
        getRatings(6, step1.id, 1)
          .then(responseData => {
            const { data } = responseData;
            const ratingImages: any[] = [];

            if (data) {
              getObject(data, "keys").forEach(key => {
                ratingImages.push(data[key]);
              });
              setRatingItemsState(ratingImages);
              setRatingState(responseData);
              setSearchResults(data);
              setCurrentSearchTabIndex(0);
            }
          })
          .catch(() => { })
          .finally(() => {
            setLoadingRating(false);
          });

        // Get total component rating by product id & keywords:
        getTotalComponentByIdAndKeywords(step1.id)
          .then(dataTotalRating => {
            setAvgRatingState(dataTotalRating.data);
          })
          .catch(() => { });

        // call tracking viewing detail product:
        gaTrackingViewingProductDetail();

      }, 2500)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step1]);

  const getTypeRating = (avg: any, typeGet: "best" | "worst") => {
    var _filtered = Object.keys(avg)
      .filter(key => avg[key])
      .reduce((obj: any, key: any) => {
        obj[key] = avg[key];
        return obj;
      }, {});
    return typeGet === "best"
      ? Math.max(...Object.keys(_filtered))
      : Math.min(...Object.keys(_filtered));
  };

  useEffect(() => {
    if (ratingItemsState && avgRatingState && step1) {
      // set structured-data:
      const { name, model: sku, price, images } = step1;

      let description = "";
      const descriptionEle = document.getElementsByClassName(
        "productinformation_description",
      );
      if (descriptionEle && descriptionEle[0]) {
        description = descriptionEle[0].textContent || "";
      }

      let listImages = images;
      if (typeof images === "string") {
        listImages = JSON.parse(images);
      }

      const listPop =
        ratingItemsState.length > 0
          ? ratingItemsState.length > 1
            ? [ratingItemsState[0], ratingItemsState[1]]
            : ratingItemsState
          : [];

      const structuredItem: ProductStructured = {
        "@context": "https://schema.org",
        "@type": "Product",
        name,
        image: Object.keys(listImages).map(key => listImages[key].thumb),
        description,
        sku,
        mpn: sku,
        brand: {
          "@type": "Thing",
          name: ["Daikin"],
        },
        ...(ratingItemsState
          ? {
            review: listPop.map(item => ({
              "@type": "Review",
              reviewRating: {
                "@type": "Rating",
                ratingValue: item?.numbers_rating?.toString(),
                bestRating: "5",
              },
              author: item.customer_name,
              datePublished: item.created_at,
              reviewBody: item.comment,
              image: item.files,
            })),
          }
          : {}),
        ...(avgRatingState && avgRatingState.total_ratings
          ? {
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: avgRatingState.avg_ratings,
              ratingCount: avgRatingState.total_ratings,
              bestRating: getTypeRating(
                avgRatingState.avg_number_each_rating,
                "best",
              ),
              worstRating: getTypeRating(
                avgRatingState.avg_number_each_rating,
                "worst",
              ),
            },
          }
          : { aggregateRating: null }),
        offers: {
          "@type": "Offer",
          url: `${SITE_URL}/${slug}`,
          priceCurrency: "VND",
          price: price || 0,
          priceValidUntil: getFeatureDateByIncreaseMonthToday(
            2,
          ).toLocaleDateString(), // 2020-11-20
          itemCondition: "https://schema.org/NewCondition",
          availability: "https://schema.org/InStock",
        },
      };

      setMetaData(prevData =>
        prevData
          ? {
            ...prevData,
            product: structuredItem,
          }
          : {
            titlePage: name,
            title: name,
            description,
            keywords: "",
            image: "",
            product: structuredItem,
          },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step1, ratingItemsState, avgRatingState]);

  const handleRequestModalListRatingPage = ({ selected: page }) => {
    if (!isNaN(page)) {
      setLoadingListRatingPage(true);
      setPageNumRatingList(page + 1);
    }
  };

  useEffect(() => {
    if (step1) {
      getRatings(
        6,
        step1.id,
        pageNumRatingList,
      )
        .then(responseData => {
          const { data } = responseData;
          const ratingImages: string[] = [];

          getObject(data, "keys").forEach(key => {
            if (data[key].files) {
              data[key].files.forEach((file: string, i: number) => {
                if (i === 0) ratingImages.push(file);
              });
            }
          });
          setRatingState(responseData);
        })
        .catch(() => { })
        .finally(() => {
          setLoadingListRatingPage(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumRatingList]);

  const resetLimitLayoutRatingImagePreview = () => {
    if (width >= 375 && width < 576) {
      setLimitLayoutRatingImagePreview(2);
    } else if (width >= 576 && width < 768) {
      setLimitLayoutRatingImagePreview(2);
    } else if (width >= 768 && width < 1024) {
      setLimitLayoutRatingImagePreview(3);
    } else if (width >= 1024 && width < 1199) {
      setLimitLayoutRatingImagePreview(4);
    } else if (width >= 1200) {
      setLimitLayoutRatingImagePreview(6);
    } else {
      setLimitLayoutRatingImagePreview(1);
    }
  };

  useEffect(() => {
    resetLimitLayoutRatingImagePreview();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  useEffect(() => {
    ratingItemsState &&
      setListImagesRatingPreview(
        ratingItemsState?.slice(0, limitLayoutRatingImagePreview),
      );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limitLayoutRatingImagePreview]);

  useEffect(() => {
    ratingItemsState &&
      setListImagesRatingPreview(
        ratingItemsState?.slice(0, limitLayoutRatingImagePreview),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratingItemsState]);

  useEffect(() => {
    if (ratingState && listImagesRatingPreview) {
      setHasMoreRatings(
        (ratingState as TypeRating1).meta.total >
        listImagesRatingPreview.length,
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listImagesRatingPreview]);

  const initGroupRating = (ratingStateParams: any) => {
    const { data } = ratingStateParams;

    const groupRatings = {
      0: {
        length: data.length,
        ratings: data,
        meta: ratingStateParams.meta,
      },
      1: data.filter(item => item.numbers_rating === 1),
      2: data.filter(item => item.numbers_rating === 2),
      3: data.filter(item => item.numbers_rating === 3),
      4: data.filter(item => item.numbers_rating === 4),
      5: data.filter(item => item.numbers_rating === 5),
    };

    setGroupRatingState(groupRatings);
  };

  const onLogout = () => {
    logout()
      .then(() => {
        dispatch(authLogout());
        dispatch(fetchCartProducts());
        window.location.reload();
      })
      .catch(() => { });
  };

  useEffect(() => {
    if (step1) {
      if (userInformation && getObject(userInformation, "keys")) {
        dispatch(
          requestValidationAccount({
            productId: step1.id,
            email: userInformation.email,
            phone: userInformation.phone || "123456789",
          }),
        );
        setCustomerId(userInformation?.id?.toString());
      } else {
        setCustomerId(getThisMachine().id);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step1, userInformation]);

  // VALIDATE RATING BUTTON:
  useEffect(() => {
    // Request validate account limit rating:
    // login:
    // userInformation
    if (
      userInformation &&
      getObject(userInformation, "keys") &&
      validationAccount &&
      getObject(validationAccount.data, "keys")
    ) {
      const accept = validationAccount.data.accept === false;
      setIsLimitRatingProduct(accept);
    }

    // unlogin:
    // get machine id:

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validationAccount]);

  const onToggleClick = () => {
    setIsShow(!isShow);
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const { data } = seen;
    if (data && Object.entries(data).length > 0) {
      setSeenList(data.data);
    }
  }, [seen]);

  useEffect(() => {
    if (seenList && seenList.data) {
      setSeenProductHasCashbackLabel(
        Array(seenList.data).every(item => item.cashback_text !== null || item.cashback_img !== null),
      );
    }
  }, [seenList]);

  const handlePostLike = (
    id: string,
    likeData: LikeType,
    inDetailView?: boolean,
  ) => {
    setPreventClosingModal(true);
    setProcessingLikePostLoading({ id, onload: true });
    postLike({
      type: likeData.type,
      customer_id: likeData.customer_id,
      id_like: likeData.id_like,
    })
      .then(() => {
        const { type, id_like, customer_id, rating_id } = likeData;
        if (ratingState && ratingState.data) {
          const likeItem = {
            id,
            customer_id,
            ...(type === LIKE_TYPE.RATING
              ? { rating_id: id_like }
              : { rating_comment_id: id_like }),
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
          };
          let updateRatingItem: any = {};

          const updateRatingState = ratingState.data.map(rating => {
            if (type === LIKE_TYPE.RATING && rating.id === id_like) {
              if (
                (rating.rating_likes &&
                  !rating.rating_likes.find(
                    findItem => findItem.customer_id === customerId,
                  )) ||
                !rating.rating_likes
              ) {
                updateRatingItem = {
                  ...rating,
                  total_likes: rating.total_likes + 1,
                  rating_likes: [...rating.rating_likes, likeItem],
                };
                return updateRatingItem;
              }
            } else if (type === LIKE_TYPE.COMMENT && rating.rating_comments) {
              const tempRating = {
                ...rating,
                rating_comments: rating.rating_comments.map(ratingComment => {
                  if (ratingComment.id === id_like) {
                    if (ratingComment.rating_comment_likes) {
                      if (
                        !ratingComment.rating_comment_likes.find(
                          findItem => findItem.customer_id === customerId,
                        )
                      ) {
                        return {
                          ...ratingComment,
                          total_likes: ratingComment.total_likes + 1,
                          rating_comment_likes: [
                            ...ratingComment.rating_comment_likes,
                            likeItem,
                          ],
                        };
                      }
                      return ratingComment;
                    }
                    return {
                      ...ratingComment,
                      total_likes: ratingComment.total_likes + 1,
                      rating_comment_likes: [
                        ...ratingComment.rating_comment_likes,
                        likeItem,
                      ],
                    };
                  }
                  return ratingComment;
                }),
              };
              if (inDetailView && rating.id === rating_id) {
                updateRatingItem = tempRating;
              }
              return tempRating;
            }
            return rating;
          });
          setRatingState({
            ...ratingState,
            data: updateRatingState,
          });
          setSearchResults(updateRatingState);
          setDetailReviewModal({
            ...detailReviewModal,
            data: updateRatingItem,
          });
        }
      })
      .catch(() => { })
      .finally(() => {
        setProcessingLikePostLoading({ id, onload: false });
        setPreventClosingModal(false);
      });
  };

  const handlePostDisLike = (
    id: string,
    dislikeData: LikeType,
    inDetailView?: boolean,
  ) => {
    setPreventClosingModal(true);
    setProcessingLikePostLoading({ id, onload: true });
    postDisLike({
      type: dislikeData.type,
      customer_id: dislikeData.customer_id,
      id_like: dislikeData.id_like,
    })
      .then(() => {
        const { type, id_like, rating_id } = dislikeData;
        let updateRatingItem = {};
        if (ratingState && ratingState.data) {
          const updateRatingState = ratingState.data.map(rating => {
            if (type === LIKE_TYPE.RATING && rating.id === id_like) {
              if (rating.rating_likes) {
                updateRatingItem = {
                  ...rating,
                  total_likes: rating.total_likes - 1,
                  rating_likes: rating.rating_likes.filter(
                    fItem => fItem.customer_id !== customerId,
                  ),
                };
                return updateRatingItem;
              }
            } else if (type === LIKE_TYPE.COMMENT && rating.rating_comments) {
              const tempRating = {
                ...rating,
                rating_comments: rating.rating_comments.map(ratingComment => {
                  if (
                    ratingComment.id === id_like &&
                    ratingComment.rating_comment_likes
                  ) {
                    return {
                      ...ratingComment,
                      total_likes: ratingComment.total_likes - 1,
                      rating_comment_likes: ratingComment.rating_comment_likes.filter(
                        fItem => fItem.customer_id !== customerId,
                      ),
                    };
                  }
                  return ratingComment;
                }),
              };
              if (inDetailView && rating.id === rating_id) {
                updateRatingItem = tempRating;
              }
              return tempRating;
            }
            return rating;
          });
          setRatingState({
            ...ratingState,
            data: updateRatingState,
          });
          setSearchResults(updateRatingState);
          setDetailReviewModal({
            ...detailReviewModal,
            data: updateRatingItem,
          });
        }
      })
      .catch(() => { })
      .finally(() => {
        setProcessingLikePostLoading({ id, onload: false });
        setPreventClosingModal(false);
      });
  };

  const checkLiked = (rating: any) =>
    rating.rating_likes &&
    rating.rating_likes.filter(
      (rlike: any) =>
        rlike.rating_id === rating.id && rlike.customer_id === customerId,
    ).length > 0;

  const checkAcceptReply = (email: string) =>
    userInformation ? userInformation.email === email : false;

  useEffect(() => {
    if (dataLightBox) {
      setLightBoxRatingItemData(
        dataLightBox.data.map(file => `${BASE_URL}/${file}`),
      );
      setLightBoxRatingItemTypes(
        dataLightBox.data.map(file => (isVideo(file) ? "video" : "image")),
      );
    }
  }, [dataLightBox]);

  useEffect(() => {
    if (lightBoxRatingItemTypes && dataLightBox) {
      setLightboxRatingItem({
        toggler: dataLightBox.toggler,
        activeSlide: dataLightBox.activeSlide,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lightBoxRatingItemTypes]);

  useEffect(() => {
    if (ratingContainerRef && ratingContainerRef.current) {
      scrollIntoRef(
        ratingContainerRef.current,
        scrollTab && scrollTab.length ? scrollTab[0].clientHeight : 0,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumRatingStateSearch]);

  const scrollToProductRating = () => {
    if (ratingContainerRef && ratingContainerRef.current) {
      scrollIntoRef(
        ratingContainerRef.current,
        scrollTab && scrollTab.length ? scrollTab[0].clientHeight : 0,
      );
    }
  };

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    if (query.get("is_rating")) {
      scrollToProductRating();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratingState]);

  useEffect(() => {
    if (
      detail &&
      detail.data &&
      notEmptyObject(detail.data) &&
      detail.data.step1
    ) {
      const { seo } = detail.data.step1;

      if (seo && seo.metaDataTranslations) {
        const {
          description,
          keywords,
          title,
          extraData,
        } = seo.metaDataTranslations[0];

        setMetaData({
          titlePage: title,
          title,
          description,
          keywords,
          image: typeof extraData === "string" && JSON.parse(extraData).image,
        });
      }
    }
  }, [detail]);

  useEffect(() => {
    // khởi tạo group rating
    // if (ratingState) {
    //   initGroupRating(ratingState);
    // }
    // call api lấy sản phẩm đã xem
    if (productIds) {
      const list = productIds && productIds.split(",").map(x => +x);
      if (list) {
        dispatch(requestFetchSeenProducts({ list }));
      }
    }
  }, [dispatch, productIds]);

  useEffect(() => {
    // khởi tạo group rating
    if (ratingState) {
      initGroupRating(ratingState);
    }
  }, [ratingState]);

  const getRatingIcon = (numberRating: number, active: boolean): any[] => {
    let stars: any[] = [];
    if (active) {
      for (let i = 1; i <= numberRating; i++) {
        stars.push(<ActiveStar key={i} icon={activeStarIcon} />);
      }
    } else {
      for (let i = 1; i <= numberRating; i++) {
        stars.push(<DeActiveStar key={i} icon={deActiveStarIcon} />);
      }
    }
    return stars;
  };

  useEffect(() => {
    // Task 1
    const reviewContainerElement = ratingContainerRef.current;
    let observer: MutationObserver | undefined;
    if (location.state && location.state.actionTarget === "rating") {
      observer = new MutationObserver(mutationsList => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            if (reviewContainerElement === mutation.target) {
              reviewContainerElement.scrollIntoView();
            }
          }
        }
      });

      observer.observe(document, {
        childList: true,
        subtree: true,
      });
    }

    // Task 2
    getTopPositionIfHasHeroCarousel();

    // Task 3

    // Task 4
    setRatingState(undefined);

    // Task 5
    updateThisMachineVisitCount();

    // Task 6
    resetLimitLayoutRatingImagePreview();

    return () => {
      // Task 1
      if (observer) observer.disconnect();

      // Task 3

      // Task 4
      // VALIDATE RATING'S COMMENTS & LIKE DISLIKE:
      // Love rating comment management:
      setRatingState(undefined);
      setSearchResults([]);
      setListImagesRatingPreview([]);
      setRatingItemsState([]);
      setAvgRatingState(undefined);
      setGroupRatingState({});
      // setDetailProduct(null);
      dispatch(resetDetailProduct());
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const productDetailWrap = () => {
    return (
      <>
        <div className="p-product-detail">
          <Section space="space-xs-t">
            <div
              className="product-detail-info"
              ref={productInfoRef}
            >
              <Grid>
                <GridRow>
                  <GridCol colXl={4} colLg={12}>
                    {step1 && step1.images.length > 0 && (
                      <>
                        <ProductCarousel
                          product={step1}
                          tag={
                            step1.discount &&
                            Object.entries(step1.discount).length >
                            0 &&
                            step1.discount.discount_value > 0 && (
                              <Tag modifiers={["sale"]}>
                                Giảm giá{" "}
                                {step1.discount.discount_type === 1
                                  ? `${step1.discount.discount_value.split(
                                    ".",
                                  )[0]
                                  }%`
                                  : `${Math.round(step1?.discount?.discount_value.split(".")[0] / step1?.price.split(".")[0] * 100)}%`}
                              </Tag>
                            )
                          }
                          onCompare={(e: any) =>
                            onCompare(
                              e,
                              step1.id,
                              step1.product_type_id,
                              step1.product_parent_type_id,
                            )
                          }
                          toggleCompare={
                            step1.product_type_id === 3 ||
                              step1.product_type_id === 4 ||
                              step1.product_type_id === 5 ||
                              step1.product_type_id === 6 ||
                              step1.product_type_id === 7 ||
                              step1.product_type_id === 8
                              ? toggleCompare
                              : null
                          }
                          data={step1 && step1.images}
                          iframe={step1?.iframe_3d}
                          plattar_url={step1?.plattar_url}
                          topTrademarks={
                            step1.trademarks.length > 0
                              ? step1.trademarks
                                .filter(tra => tra.location === 1)
                                .map(found => found.image)
                                .slice(0, 3)
                              : []
                          }
                          bottomTrademarks={
                            step1.trademarks.length > 0
                              ? step1.trademarks
                                .filter(tra => tra.location === 2)
                                .map(found => found.image)
                                .slice(0, 4)
                              : []
                          }
                        />
                        <div
                          className={`productinformation_description ${isShow ? "show" : ""
                            }`}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                (step1 &&
                                  step1.description) ||
                                "",
                            }}
                          ></div>
                        </div>
                        <div
                          onClick={onToggleClick}
                          className={`productinformation_viewmore ${isShow ? "show" : ""
                            } `}
                        >
                          {isShow ? "Thu gọn" : "Xem thêm đặc điểm nổi bật"}
                        </div>

                        <div className="o-productinformation_line"></div>

                        <div className="o-productinformation_functionair">
                          {step1.features.length > 0 &&
                            step1.features.map((f: any, i: number) => (
                              <Productfeature
                                imgSrc={`${BASE_URL}${f.image}`}
                                title={f.name}
                                description={f.description}
                                key={i}
                              />
                            ))}
                        </div>
                      </>
                    )}
                  </GridCol>
                  <GridCol colXl={8} colLg={12}>
                    {step1 && (
                      <ProductInfomation
                        onToggleInfoBuyingForm={onToggleInfoBuyingForm}
                        detail={step1}
                        step2={step2}
                        passQuantity={getQuantity}
                        onScrollToRatingSection={scrollToProductRating}
                      />
                    )}
                  </GridCol>
                </GridRow>
              </Grid>
            </div>
          </Section>

          {
            // PRODUCT INFO REMAINING
          }
          <LazyLoad once offset={200}>
            {step12 && (
              <Section className="section-product-detail-info-tabset">
                <div className="product-detail-info-tabset" ref={productTabRef}>
                  <ScrollTabProductDetail
                    onToggleInfoBuyingForm={onToggleInfoBuyingForm}
                    detailProduct={step12}
                    productInfoRef={productInfoRef}
                    productTabRef={productTabRef}
                    quantity={quantity}
                  />
                </div>
              </Section>
            )}

            {
              // PRODUCT INFO REMAINING
            }
            {step12 && (
              <>
                {!!step12.related_products.length && (
                  <div id="relatedProduct">
                    <Section
                      space="space-xs-b"
                      className="section-pt"
                      ref={relatedProductRef}
                    >
                      <Grid>
                        <GridRow>
                          <GridCol>
                            <Carousel
                              pagination
                              title={"Sản phẩm liên quan"}
                              breakpoints={PRODUCT_DETAIL(4)}
                              id={`product-detail-${CAROUSEL_IDS.DETAIL_RELATED_PRODUCTS}`}
                              className={joinClassnames(
                                `${step12.related_products.length <= 4 &&
                                "item-less-than-4"}`,
                              )}
                            >
                              {step12.related_products.map(
                                p =>
                                  p.product_id !== step12.id && (
                                    <SwiperSlide key={p.id}>
                                      <CarouselItem>
                                        <Product
                                          product={p}
                                          addToCardButton={true}
                                          onCompare={(e: any) => onCompare(e, p.id, p.productTypeId, p.parentTypeId)}
                                          className="no-animate-item"
                                          tags={
                                            p.tags && p.tags.length > 0
                                              ? p.tags.map((tag, index) => (
                                                <div
                                                  key={index}
                                                  className="m-product_trademark_item service"
                                                >
                                                  <Text
                                                    modifiers={["primary"]}
                                                    size="sm"
                                                  >
                                                    {tag.name}
                                                  </Text>
                                                </div>
                                              ))
                                              : []
                                          }
                                          trademarks={
                                            p.trademarks.length > 0
                                              ? p.trademarks.map(tra => tra.name)
                                              : []
                                          }
                                          hasCashbackLabel={step12.related_products.some(
                                            item => item.cashback_text !== null || item.cashback_img !== null,
                                          )}
                                          onToggleInfoBuyingForm={
                                            onToggleInfoBuyingForm
                                          }
                                          onBuyingNow={() => {
                                            // call on click buying now
                                            // handleBuyingNow(p);
                                          }}
                                          list="relatived-products"
                                        />
                                      </CarouselItem>
                                    </SwiperSlide>
                                  ),
                              )}
                            </Carousel>
                          </GridCol>
                        </GridRow>
                      </Grid>
                    </Section>
                  </div>
                )}
              </>
            )}

            {
              // PRODUCT INFO REMAINING
            }
            {step12 && (
              <RatingSection ref={ratingContainerRef} id="rating-section">
                {loadingRating && <LoadingBox label="Đang tải đánh giá" />}
                {ratingState &&
                  ratingState.data &&
                  getObject(ratingState.data, "keys") &&
                  step1 && (
                    <>
                      <ReviewGrid>
                        <Grid className="review-grid">
                          <GridRow no_gutters>
                            <ReviewContainer>
                              <ReviewHeading>
                                <ReviewTitle>
                                  ĐÁNH GIÁ {step12?.name?.toUpperCase()}
                                </ReviewTitle>
                                <Button
                                  onClick={() => {
                                    setReviewModal(true);
                                  }}
                                  disabled={isLimitRatingProduct}
                                >
                                  ĐÁNH GIÁ NGAY
                                </Button>
                              </ReviewHeading>

                              <ReviewBody>
                                <RatingContainer>
                                  <RatingHeading>
                                    <RatingValue
                                      value={
                                        (avgRatingState &&
                                          avgRatingState.avg_ratings) ||
                                        0
                                      }
                                    >
                                      {(avgRatingState &&
                                        avgRatingState.avg_ratings) ||
                                        0}
                                    </RatingValue>
                                    {avgRatingState && (
                                      <>
                                        <Rcrating
                                          size={24}
                                          colorActive={colors.tangerine}
                                          defaultValue={avgRatingState.avg_ratings}
                                          disabled
                                        />
                                      </>
                                    )}
                                    <RatingCounterLabel>
                                      {avgRatingState
                                        ? avgRatingState.total_ratings || 0
                                        : 0}{" "}
                                      đánh giá
                                    </RatingCounterLabel>
                                  </RatingHeading>
                                  <RatingBody>
                                    {getObject(groupRatingState, "keys")
                                      .sort((a, b) => b - a)
                                      .map((ratingKey, ratingIndex) =>
                                        ratingKey > 0 ? (
                                          <UIReviewStat key={ratingIndex}>
                                            <UIReviewStatTitle>
                                              {ratingKey}&nbsp;
                                              <Icon iconName="star-gray" />
                                            </UIReviewStatTitle>
                                            <UIProgress>
                                              <UIProgressLine>
                                                <ProgressLine>
                                                  <ProgressFill
                                                    value={
                                                      avgRatingState
                                                        ? avgRatingState
                                                          .avg_percent_each_rating[
                                                        ratingKey
                                                        ] || 0
                                                        : 0
                                                    }
                                                    color={colors.tangerine}
                                                  />
                                                </ProgressLine>
                                              </UIProgressLine>
                                              &nbsp;&nbsp;
                                              <UIProgressStatValue>
                                                <UIProgressStatValueStat>
                                                  {`${avgRatingState
                                                    ? avgRatingState
                                                      .avg_percent_each_rating[
                                                    ratingKey
                                                    ] || 0
                                                    : 0
                                                    }%`}
                                                </UIProgressStatValueStat>
                                                &nbsp;|&nbsp;
                                                <UIProgressStatValueReview>
                                                  {avgRatingState
                                                    ? avgRatingState
                                                      .avg_number_each_rating[
                                                    ratingKey
                                                    ] || 0
                                                    : 0}{" "}
                                                  đánh giá
                                                </UIProgressStatValueReview>
                                              </UIProgressStatValue>
                                            </UIProgress>
                                          </UIReviewStat>
                                        ) : null,
                                      )}
                                  </RatingBody>
                                </RatingContainer>
                                <CriteriaContainer>
                                  <CriteriaHeading>
                                    {avgRatingState &&
                                      getObject(
                                        avgRatingState.total_criterias,
                                        "keys",
                                      ).length}{" "}
                                    tiêu chí đánh giá
                                  </CriteriaHeading>
                                  <CriteriaBody>
                                    {avgRatingState &&
                                      getObject(
                                        avgRatingState.total_criterias,
                                        "keys",
                                      ).map((itemKey, avgRatingIndex) => {
                                        const avgItem =
                                          avgRatingState.total_criterias[itemKey];
                                        return (
                                          <UIReviewStat key={avgRatingIndex}>
                                            <UIReviewStatTitle>
                                              {avgItem.name}
                                            </UIReviewStatTitle>
                                            <UIProgress>
                                              <UIProgressStatValue>
                                                <UIProgressStatValueStat>
                                                  {avgItem.percent &&
                                                    avgItem.percent.yes &&
                                                    String(
                                                      avgItem.percent.yes,
                                                    ).replace(" ", "")}
                                                  %
                                                </UIProgressStatValueStat>
                                                &nbsp;|&nbsp;
                                                <UIProgressStatValueReview>
                                                  Có
                                                </UIProgressStatValueReview>
                                              </UIProgressStatValue>
                                              &nbsp;&nbsp;
                                              <UIProgressLine>
                                                <ProgressLine>
                                                  <ProgressFill
                                                    value={
                                                      avgItem.percent &&
                                                      avgItem.percent.yes &&
                                                      `${avgItem.percent.yes}%`
                                                    }
                                                    color={colors.richElectricBlue}
                                                  />
                                                </ProgressLine>
                                              </UIProgressLine>
                                              &nbsp;&nbsp;
                                              <UIProgressStatValue>
                                                <UIProgressStatValueStat>
                                                  {avgItem.percent &&
                                                    avgItem.percent.no &&
                                                    String(
                                                      avgItem.percent.no,
                                                    ).replace(" ", "")}
                                                  %
                                                </UIProgressStatValueStat>
                                                &nbsp;|&nbsp;
                                                <UIProgressStatValueReview>
                                                  Không
                                                </UIProgressStatValueReview>
                                              </UIProgressStatValue>
                                            </UIProgress>
                                          </UIReviewStat>
                                        );
                                      })}
                                  </CriteriaBody>
                                </CriteriaContainer>
                              </ReviewBody>
                            </ReviewContainer>
                          </GridRow>
                        </Grid>
                      </ReviewGrid>

                      {
                        // ẢNH TỪ KHÁCH HÀNG
                      }
                      <ReviewGrid>
                        <Grid className="client-upload-images-grid">
                          <GridRow no_gutters>
                            <GridHeading>
                              {limitLayoutRatingImagePreview >= 6
                                ? avgRatingState
                                  ? avgRatingState.total_images || 0
                                  : 0
                                : listImagesRatingPreview.length}{" "}
                              ảnh từ khách hàng
                            </GridHeading>
                            <ClientUploadImageList
                              justifyContent={
                                listImagesRatingPreview.length >=
                                  6
                                  ? "space-between"
                                  : "flex-start"
                              }
                            >
                              {ratingItemsState &&
                                listImagesRatingPreview.map(
                                  (ratingItemState, index) =>
                                    ratingItemState.files &&
                                    ratingItemState.files.length && (
                                      <ClientUploadImagePreviewItem
                                        key={index}
                                        onClick={() => {
                                          index < listImagesRatingPreview.length - 1
                                            ? setDetailReviewModal({
                                              status: true,
                                              data: ratingItemState,
                                            })
                                            : setListReviewModal(true);
                                        }}
                                        isLast={
                                          index ===
                                          listImagesRatingPreview.length - 1
                                        }
                                      >
                                        {ratingItemState.files &&
                                          isVideo(ratingItemState.files[0]) ? (
                                          <VideoPanelPreviewItem
                                            ratioAt={SizeMin.Medium}
                                          >
                                            <Player
                                              src={`${BASE_URL}/${ratingItemState.files[0]}`}
                                              ratio={1}
                                              justClick
                                              hideIcon={
                                                index ===
                                                listImagesRatingPreview.length - 1
                                              }
                                            />
                                          </VideoPanelPreviewItem>
                                        ) : (
                                          <ClientUploadImageItem
                                            src={`${BASE_URL}/${ratingItemState.files[0]}`}
                                          />
                                        )}
                                        {index ===
                                          listImagesRatingPreview.length - 1 &&
                                          hasMoreRatings && (
                                            <span>Xem Tất Cả Hình Ảnh</span>
                                          )}
                                      </ClientUploadImagePreviewItem>
                                    ),
                                )}
                            </ClientUploadImageList>
                          </GridRow>
                        </Grid>
                      </ReviewGrid>
                      <ReviewGrid>
                        <Grid className="review-chat-grid">
                          <GridRow no_gutters>
                            <GridReviewChatHeading>
                              <GridReviewChatTitle ref={ratingCountingLandRef}>
                                {(ratingState &&
                                  ratingState.meta &&
                                  ratingState.meta.total) ||
                                  0}{" "}
                                đánh giá
                              </GridReviewChatTitle>
                              {searchResults && (
                                <TabList>
                                  <TabListItem
                                    className={
                                      (currentSearchTabIndex === 0 && "active") ||
                                      ""
                                    }
                                    onClick={() => {
                                      if (ratingState) {
                                        setSearchResults(ratingState.data);
                                      }
                                      setCurrentSearchTabIndex(0);
                                    }}
                                  >
                                    Tất Cả
                                  </TabListItem>
                                  {[5, 4, 3, 2, 1].map((item, tabIndex) => (
                                    <TabListItem
                                      key={tabIndex}
                                      className={
                                        (currentSearchTabIndex === item &&
                                          "active") ||
                                        ""
                                      }
                                      onClick={() => {
                                        setCurrentSearchTabIndex(item);
                                      }}
                                    >
                                      {item} Sao
                                    </TabListItem>
                                  ))}
                                </TabList>
                              )}
                            </GridReviewChatHeading>
                            <ClientCommentReviews>
                              <ClientCommentSearchBar className="form-h-search">
                                <label htmlFor="searchKey" className="search-label">
                                  Kết quả tìm kiếm từ khóa
                                </label>
                                <SearchBarWrapper>
                                  <ReactTags
                                    autofocus={false}
                                    tags={tags}
                                    handleDelete={handleDelete}
                                    handleAddition={handleAddition}
                                    delimiters={delimiters}
                                    classNames={{
                                      tags: "search-client-review-tags",
                                      tagInput: "search-client-review-tagInput",
                                      tagInputField:
                                        "search-client-review-tagInputField",
                                      selected: "search-client-review-selected",
                                      tag: "search-client-review-tag",
                                      remove: "search-client-review-remove",
                                      suggestions:
                                        "search-client-review-suggestions",
                                      activeSuggestion:
                                        "search-client-review-activeSuggestion",
                                    }}
                                    placeholder="Vui lòng nhập từ khoá tìm kiếm"
                                    allowDragDrop={false}
                                    inline={true}
                                    inputFieldPosition="inline"
                                  />
                                  <SearchBarButton variant="link" type="submit">
                                    <Icon iconName="search" />
                                  </SearchBarButton>
                                </SearchBarWrapper>
                              </ClientCommentSearchBar>

                              {loadingSearchRatings ? (
                                <LoadingBox label="Đang tải rating" />
                              ) : searchResults && searchResults.length > 0 ? (
                                searchResults.map((rating, index) => {
                                  const liked =
                                    rating.rating_likes &&
                                    rating.rating_likes.filter(
                                      item =>
                                        item.rating_id === rating.id &&
                                        item.customer_id === customerId,
                                    ).length > 0;
                                  return (
                                    <ClientCommentReviewWrap key={index}>
                                      <ClientCommentReviewItem>
                                        <ClientCommentReviewTitle>
                                          <LeftCLientCommentReview>
                                            {rating.customer_name}&nbsp;
                                            <VerifyBuyAtDaikinEShop
                                              icon={checkCircleOutlineGreen}
                                            >
                                              Đã mua tại Daikin Eshop
                                            </VerifyBuyAtDaikinEShop>
                                            &nbsp;
                                          </LeftCLientCommentReview>
                                          <TagViews>
                                            {rating.rating_criterias &&
                                              rating.rating_criterias.map(
                                                (
                                                  ratingCriteria,
                                                  ratingCriteriaIndex,
                                                ) =>
                                                  ratingCriteria.tags &&
                                                  ratingCriteria.tags.map(
                                                    ratingCriteriaTag => (
                                                      <TagReview
                                                        key={ratingCriteriaIndex}
                                                      >
                                                        {ratingCriteriaTag}
                                                      </TagReview>
                                                    ),
                                                  ),
                                              )}
                                          </TagViews>
                                        </ClientCommentReviewTitle>
                                        <ClientCommentReviewContent>
                                          <RcRatingWrapper>
                                            <Rcrating
                                              size={16}
                                              colorActive={colors.tangerine}
                                              defaultValue={rating.numbers_rating}
                                              disabled
                                            />
                                          </RcRatingWrapper>
                                          {rating.comment}
                                        </ClientCommentReviewContent>
                                        <ClientUploadImageList wrap="1">
                                          {rating.files &&
                                            rating.files.map(
                                              (ratingFile, ratingIndex) => (
                                                <ClientUploadImageDetailItem
                                                  key={`ClientUploadImageDetailItem-${ratingFile}`}
                                                  onClick={() => {
                                                    setDataLightbox({
                                                      toggler: !lightboxRatingItem.toggler,
                                                      data: rating.files,
                                                      activeSlide: ratingIndex + 1,
                                                    });
                                                  }}
                                                  isVideoItem={
                                                    isVideo(ratingFile) !== null
                                                  }
                                                >
                                                  {isVideo(ratingFile) ? (
                                                    <VideoPanelSearchItem
                                                      ratioAt={SizeMin.Medium}
                                                    >
                                                      <Player
                                                        src={`${BASE_URL}/${ratingFile}`}
                                                        ratio={1}
                                                        justClick
                                                      />
                                                    </VideoPanelSearchItem>
                                                  ) : (
                                                    <ClientUploadImageItem
                                                      src={
                                                        BASE_URL + "/" + ratingFile
                                                      }
                                                    />
                                                  )}
                                                </ClientUploadImageDetailItem>
                                              ),
                                            )}
                                        </ClientUploadImageList>
                                        <ClientCommentReviewStatusBar>
                                          {rating.rating_comments &&
                                            rating.rating_comments.length > 0 && (
                                              <ReplyStatus
                                                hasReply={
                                                  rating.rating_comments &&
                                                  rating.rating_comments.length
                                                }
                                              >
                                                {(rating.rating_comments &&
                                                  rating.rating_comments.length) ||
                                                  ""}{" "}
                                                Trả lời
                                              </ReplyStatus>
                                            )}
                                          {processingLikePostLoading.id ===
                                            `rating-${rating.id}` &&
                                            processingLikePostLoading.onload ? (
                                            <Icon iconName="small-loading" />
                                          ) : (
                                            <ReplyLove
                                              actived={rating.total_likes}
                                              icon={liked ? heartBlue : heartGray}
                                              iconHover={heartBlue}
                                              onClick={() => {
                                                liked
                                                  ? handlePostDisLike(
                                                    `rating-${rating.id}`,
                                                    {
                                                      type: LIKE_TYPE.RATING,
                                                      customer_id: customerId,
                                                      id_like: rating.id,
                                                    },
                                                  )
                                                  : handlePostLike(
                                                    `rating-${rating.id}`,
                                                    {
                                                      type: LIKE_TYPE.RATING,
                                                      customer_id: customerId,
                                                      id_like: rating.id,
                                                    },
                                                  );
                                              }}
                                            >
                                              {" "}
                                              {rating.total_likes &&
                                                rating.total_likes > 0
                                                ? rating.total_likes
                                                : ""}{" "}
                                              {liked ? "Bỏ thích" : "Thích"}
                                            </ReplyLove>
                                          )}
                                          <ReplyDivider>|</ReplyDivider>
                                          <ReplyDuration>
                                            {getTimeAgo(rating.created_at)}
                                          </ReplyDuration>
                                        </ClientCommentReviewStatusBar>
                                        {rating.rating_comments &&
                                          rating.rating_comments.length > 0 &&
                                          rating.rating_comments.map(
                                            (ratingComment, ratingCommentIndex) => {
                                              const liked =
                                                ratingComment.rating_comment_likes &&
                                                ratingComment.rating_comment_likes.filter(
                                                  item =>
                                                    item.rating_comment_id ===
                                                    ratingComment.id &&
                                                    item.customer_id === customerId,
                                                ).length > 0;
                                              return (
                                                <ClientCommentReviewItemInner
                                                  key={ratingCommentIndex}
                                                >
                                                  <ClientCommentReviewTitle>
                                                    {ratingComment.user === "admin"
                                                      ? "Quản trị viên"
                                                      : ratingComment.customer_name}
                                                    &nbsp;
                                                    <VerifyBuyAtDaikinEShop
                                                      icon={
                                                        ratingComment.user ===
                                                          "admin"
                                                          ? checkCircleOutlineBlue
                                                          : checkCircleOutlineGreen
                                                      }
                                                      isAdmin={
                                                        ratingComment.user ===
                                                        "admin"
                                                      }
                                                    >
                                                      {ratingComment.user ===
                                                        "admin"
                                                        ? "QTV"
                                                        : "Khách"}
                                                    </VerifyBuyAtDaikinEShop>
                                                  </ClientCommentReviewTitle>
                                                  <ClientCommentReviewContent>
                                                    <span>
                                                      {ratingComment.comment}
                                                    </span>
                                                  </ClientCommentReviewContent>
                                                  <ClientCommentReviewStatusBar>
                                                    <ReplyLove
                                                      actived={
                                                        ratingComment.total_likes
                                                      }
                                                      icon={
                                                        liked
                                                          ? heartBlue
                                                          : heartGray
                                                      }
                                                      iconHover={heartBlue}
                                                      onClick={() => {
                                                        liked
                                                          ? handlePostDisLike(
                                                            `comment-${ratingComment.id}`,
                                                            {
                                                              type:
                                                                LIKE_TYPE.COMMENT,
                                                              customer_id: customerId,
                                                              id_like:
                                                                ratingComment.id,
                                                              rating_id:
                                                                ratingComment.rating_id,
                                                            },
                                                          )
                                                          : handlePostLike(
                                                            `comment-${ratingComment.id}`,
                                                            {
                                                              type:
                                                                LIKE_TYPE.COMMENT,
                                                              customer_id: customerId,
                                                              id_like:
                                                                ratingComment.id,
                                                              rating_id:
                                                                ratingComment.rating_id,
                                                            },
                                                          );
                                                      }}
                                                    >
                                                      {" "}
                                                      {processingLikePostLoading.id ===
                                                        `comment-${ratingComment.id}` &&
                                                        processingLikePostLoading.onload ? (
                                                        <Icon iconName="small-loading" />
                                                      ) : ratingComment.total_likes &&
                                                        ratingComment.total_likes >
                                                        0 ? (
                                                        ratingComment.total_likes
                                                      ) : (
                                                        ""
                                                      )}{" "}
                                                      {liked ? "Bỏ thích" : "Thích"}
                                                    </ReplyLove>
                                                    <ReplyDivider>|</ReplyDivider>
                                                    <ReplyDuration>
                                                      {getTimeAgo(
                                                        ratingComment.created_at,
                                                      )}
                                                    </ReplyDuration>
                                                  </ClientCommentReviewStatusBar>
                                                </ClientCommentReviewItemInner>
                                              );
                                            },
                                          )}
                                        <ClientCommentReviewItem>
                                          {userInformation ? (
                                            checkAcceptReply(
                                              rating.customer_email,
                                            ) ? (
                                              <InputReview
                                                name="input-review"
                                                placeholder="Trả lời đánh giá"
                                                onClick={() => {
                                                  setShowCommentPopUp({
                                                    ratingId: rating.id,
                                                    status: true,
                                                  });
                                                }}
                                              />
                                            ) : null
                                          ) : (
                                            <InputReview
                                              name="input-review"
                                              placeholder="Trả lời đánh giá"
                                              onClick={() => {
                                                setShowCommentPopUp({
                                                  ratingId: rating.id,
                                                  status: true,
                                                });
                                              }}
                                            />
                                          )}
                                        </ClientCommentReviewItem>
                                      </ClientCommentReviewItem>
                                    </ClientCommentReviewWrap>
                                  );
                                })
                              ) : ratingState &&
                                searchResults &&
                                searchResults.length === 0 ? (
                                <div>Không có dữ liệu</div>
                              ) : null}
                            </ClientCommentReviews>
                          </GridRow>
                        </Grid>
                      </ReviewGrid>
                      {ratingState &&
                        ratingState.meta &&
                        ratingState.meta.totalPages > 1 &&
                        ratingState.meta.totalPages >= ratingState.meta.page && (
                          <PaginationExtened
                            initialPage={pageNumRatingStateSearch}
                            limit={6}
                            totalCount={
                              ratingState.meta.totalPages * 6
                            }
                            handlePageClick={handleRatingStateSearchRequestPage}
                          />
                        )}
                    </>
                  )}
              </RatingSection>
            )}

            {
              // PRODUCT INFO REMAINING
            }
            {step12 && (
              <>
                {
                  // Sản phẩm đã xem
                }
                {seenList.length > 0 && (
                  <Section
                    space="space-xs-b"
                    modifiers={["gray"]}
                    className="daikin-seen-products section-pt"
                  >
                    <Grid>
                      <GridRow>
                        <GridCol>
                          <div className="titleSection">
                            <Heading modifiers={["uppercase"]}>
                              SẢN PHẨM ĐÃ XEM
                            </Heading>
                            <div
                              className="viewMore desktop"
                              onClick={() =>
                                history.push("/tai-khoan?t=seen-products")
                              }
                            >
                              <Text weight="bold" modifiers={["primary"]}>
                                XEM TẤT CẢ
                              </Text>
                            </div>
                          </div>
                        </GridCol>
                        <GridCol>
                          {
                            <Carousel
                              pagination={seenList.length > 1}
                              breakpoints={SEEN_PRODUCT()}
                              id={`product-detail-${CAROUSEL_IDS.SEEN_PRODUCTS}`}
                              className={joinClassnames(
                                `${(seenList.length < 3 && "list-less-than-3-item") ||
                                (seenList.length < 2 && "list-less-than-2-item") ||
                                (seenList.length <= 4 && "list-4-item")}`,
                              )}
                            >
                              {seenList.map(product => (
                                <SwiperSlide key={product.id}>
                                  <CarouselItem>
                                    <Product
                                      product={product}
                                      addToCardButton={true}
                                      onCompare={onCompare}
                                      className="no-animate-item"
                                      hasCashbackLabel={seenProductHasCashbackLabel}
                                      trademarks={
                                        product.trademarks &&
                                          product.trademarks.length > 0
                                          ? product.trademarks.map(tra => tra.name)
                                          : []
                                      }
                                      tags={
                                        product.tags && product.tags.length > 0
                                          ? product.tags.map((tag, tagIndex) => (
                                            <div
                                              className="m-product_trademark_item service"
                                              key={tagIndex}
                                            >
                                              <Text modifiers={["primary"]} size="sm">
                                                {tag.name}
                                              </Text>
                                            </div>
                                          ))
                                          : []
                                      }
                                      onToggleInfoBuyingForm={onToggleInfoBuyingForm}
                                    />
                                  </CarouselItem>
                                </SwiperSlide>
                              ))}
                            </Carousel>
                          }
                        </GridCol>
                      </GridRow>
                    </Grid>
                  </Section>
                )}

                {
                  // PRODUCT INFO REMAINING
                }
                {reviewModal && step12 && (
                  <CustomerReviewModal
                    isOpen={reviewModal}
                    className="customerReviewModal"
                    onCloseRequest={() => setReviewModal(false)}
                    portalClassName="portal-review-modal"
                    isSafari={getBrowser() === BROWSERS.AppleSafari}
                  >
                    <ModalHeader onCloseRequest={() => setReviewModal(false)}>
                      <TextExtended
                        size="lg"
                        weight="bold"
                        modifiers={["uppercase", "center"]}
                      >
                        {`Đánh Giá ${step12.name}`.toUpperCase()}
                      </TextExtended>
                    </ModalHeader>
                    <ModalBody>
                      <ReviewProductForm
                        productId={step12.id}
                        onSubmitReviewProductForm={onSubmitReviewProductForm}
                        onLogout={onLogout}
                        onloading={questionForClientLoading}
                      />
                    </ModalBody>
                  </CustomerReviewModal>
                )}

                {
                  // List Review Modal
                }
                {isAvailableObject(groupRatingState) && (
                  <>
                    <CustomerListReviewModal
                      isOpen={listReviewModal}
                      className="customerListReviewModal"
                      onCloseRequest={() => setListReviewModal(false)}
                      portalClassName="portal-reviews-modal"
                    >
                      <ModalHeader onCloseRequest={() => setListReviewModal(false)}>
                        <Text size="lg" weight="bold" modifiers={["uppercase", "center"]}>
                          HÌNH ẢNH ĐÁNH GIÁ
                        </Text>
                      </ModalHeader>
                      <ModalBody>
                        <Tabs modifiers={["big", "primary"]}>
                          <TabList>
                            {getObject(groupRatingState, "keys").map(
                              (groupRatingStateKey, sTabindex) => (
                                <STab
                                  key={sTabindex}
                                  onClick={() => {
                                    setSelectedReviewTab(groupRatingStateKey);
                                  }}
                                  selected={selectedReviewTab === groupRatingStateKey}
                                >
                                  {groupRatingStateKey?.toString() === "0"
                                    ? "Tất cả"
                                    : `${groupRatingStateKey} Sao`}{" "}
                                  (
                                  {
                                    (groupRatingState as TypeRating2)[groupRatingStateKey]
                                      .length
                                  }
                                  )
                                </STab>
                              ),
                            )}
                          </TabList>
                          {getObject(groupRatingState, "keys").map(
                            groupRatingStateKey => (
                              <TabPanel key={groupRatingStateKey}>
                                <AnimateBox>
                                  {loadingListRatingPage && (
                                    <LoadingBox label="Đang tải review" />
                                  )}
                                  {groupRatingStateKey > 0 ? (
                                    !!(groupRatingState as TypeRating2)[
                                      groupRatingStateKey
                                    ].length ? (
                                      <InfiniteScrollExtendedOuter>
                                        {(groupRatingState as TypeRating2)[
                                          groupRatingStateKey
                                        ].map((item, index) => (
                                          <ReviewItem
                                            key={`review-item-key-${index}`}
                                            onClick={() => {
                                              setDetailReviewModal({
                                                status: true,
                                                data: item,
                                              });
                                            }}
                                            isVideoItem={
                                              item.files &&
                                              isVideo(item.files[0]) !== null
                                            }
                                            ratio={1.1826484018} // 259 / 219
                                          >
                                            <ReviewItemInner>
                                              <ReviewItemImgWrapper>
                                                {item.files && isVideo(item.files[0]) ? (
                                                  <Player
                                                    src={`${BASE_URL}/${item.files[0]}`}
                                                    ratio={1}
                                                    justClick
                                                  />
                                                ) : (
                                                  <ReviewItemImg
                                                    src={
                                                      item.files
                                                        ? `${BASE_URL}/${item.files[0]}`
                                                        : "https://via.placeholder.com/220x220&text=220x220"
                                                    }
                                                  />
                                                )}
                                              </ReviewItemImgWrapper>
                                              <ReviewItemRating role="Rating item">
                                                {getRatingIcon(item.numbers_rating, true)}
                                                {getRatingIcon(
                                                  5 - item.numbers_rating,
                                                  false,
                                                )}
                                              </ReviewItemRating>
                                            </ReviewItemInner>
                                          </ReviewItem>
                                        ))}
                                      </InfiniteScrollExtendedOuter>
                                    ) : (
                                      <UIPlaceholder size="small" />
                                    )
                                  ) : (groupRatingState as TypeRating1)[
                                    groupRatingStateKey
                                  ].ratings.length ? (
                                    <InfiniteScrollExtendedOuter>
                                      {(groupRatingState as TypeRating1)[
                                        groupRatingStateKey
                                      ].ratings.map((item, index) => (
                                        <ReviewItem
                                          key={`review-item-key-${index}`}
                                          onClick={() => {
                                            setDetailReviewModal({
                                              status: true,
                                              data: item,
                                            });
                                          }}
                                          isVideoItem={
                                            item.files && isVideo(item.files[0]) !== null
                                          }
                                          ratio={1.1826484018} // 259 / 219
                                        >
                                          <ReviewItemInner>
                                            <ReviewItemImgWrapper>
                                              {item.files && isVideo(item.files[0]) ? (
                                                <Player
                                                  src={`${BASE_URL}/${item.files[0]}`}
                                                  ratio={1}
                                                  justClick
                                                />
                                              ) : (
                                                <ReviewItemImg
                                                  src={
                                                    item.files
                                                      ? `${BASE_URL}/${item.files[0]}`
                                                      : "https://via.placeholder.com/220x220&text=220x220"
                                                  }
                                                />
                                              )}
                                            </ReviewItemImgWrapper>
                                            <ReviewItemRating role="Rating item">
                                              {getRatingIcon(item.numbers_rating, true)}
                                              {getRatingIcon(
                                                5 - item.numbers_rating,
                                                false,
                                              )}
                                            </ReviewItemRating>
                                          </ReviewItemInner>
                                        </ReviewItem>
                                      ))}
                                    </InfiniteScrollExtendedOuter>
                                  ) : (
                                    <UIPlaceholder size="small" />
                                  )}

                                  {
                                    // pagination list rating
                                  }
                                  {(groupRatingState as TypeRating1)[0].meta ? (
                                    <PaginationExtened
                                      initialPage={pageNumRatingList}
                                      limit={6}
                                      totalCount={
                                        (groupRatingState as TypeRating1)[0].meta
                                          .totalPages * 6
                                      }
                                      handlePageClick={handleRequestModalListRatingPage}
                                    />
                                  ) : null}
                                </AnimateBox>
                              </TabPanel>
                            ),
                          )}
                        </Tabs>
                      </ModalBody>
                    </CustomerListReviewModal>

                    {
                      // Detail Review Modal
                    }
                    {detailReviewModal &&
                      detailReviewModal.status &&
                      detailReviewModal.data && (
                        <CustomerListReviewModal
                          isOpen={detailReviewModal.status}
                          className="customerListReviewModal"
                          onCloseRequest={() =>
                            preventClosingModal
                              ? undefined
                              : setDetailReviewModal({
                                status: false,
                                data: null,
                              })
                          }
                          portalClassName="portal-detail-review-modal"
                        >
                          <ModalHeader
                            onCloseRequest={() =>
                              preventClosingModal
                                ? undefined
                                : setDetailReviewModal({
                                  status: false,
                                  data: null,
                                })
                            }
                          >
                            <Text
                              size="lg"
                              weight="bold"
                              modifiers={["uppercase", "center"]}
                            >
                              Đánh Giá Chi Tiết
                            </Text>
                          </ModalHeader>
                          <ModalBody>
                            <ModalBodyInner>
                              <ContentBlock>
                                <RatingImageSlider className="rating-image-detail">
                                  {detailReviewModal.data.files &&
                                    detailReviewModal.data.files ? (
                                    <Swiper
                                      {...reviewModalSwiperConfig}
                                    >
                                      {reviewModalSwiperItem}
                                    </Swiper>
                                  ) : (
                                    <UIPlaceholder size="small" />
                                  )}
                                </RatingImageSlider>
                                <RatingInformation>
                                  <RatingInformationDetailModalTitle>
                                    {detailReviewModal.data.customer_name}&nbsp;
                                    <VerifyBuyAtDaikinEShop
                                      icon={checkCircleOutlineGreen}
                                    >
                                      Đã mua tại Daikin Eshop
                                    </VerifyBuyAtDaikinEShop>
                                  </RatingInformationDetailModalTitle>
                                  <ClientCommentReviewContent>
                                    <RcRatingWrapper>
                                      <Rcrating
                                        size={14}
                                        colorActive={colors.tangerine}
                                        defaultValue={
                                          detailReviewModal.data.numbers_rating || 0
                                        }
                                        disabled
                                      />
                                      {detailReviewModal.data.comment}
                                    </RcRatingWrapper>
                                  </ClientCommentReviewContent>
                                  <ListTagView>
                                    <ListTagViewInner>
                                      {detailReviewModal.data.rating_criterias &&
                                        detailReviewModal.data.rating_criterias.map(
                                          ratingCri =>
                                            ratingCri.tags.map(ratingCriTag => (
                                              <TagReview key={`key-${ratingCriTag}`}>
                                                {ratingCriTag}
                                              </TagReview>
                                            )),
                                        )}
                                    </ListTagViewInner>
                                  </ListTagView>
                                </RatingInformation>
                              </ContentBlock>

                              <ActionAndDatingBlock>
                                <ClientCommentReviewStatusBar>
                                  {detailReviewModal.rating_comments &&
                                    detailReviewModal.rating_comments.length && (
                                      <ReplyStatus
                                        hasReply={
                                          detailReviewModal.rating_comments &&
                                          detailReviewModal.rating_comments.length
                                        }
                                      >
                                        {detailReviewModal.rating_comments &&
                                          detailReviewModal.rating_comments.length}{" "}
                                        Trả lời
                                      </ReplyStatus>
                                    )}
                                  {processingLikePostLoading.id ===
                                    `rating-${detailReviewModal.data.id}` &&
                                    processingLikePostLoading.onload ? (
                                    <Icon iconName="small-loading" />
                                  ) : (
                                    <ReplyLove
                                      actived={detailReviewModal.data.total_likes}
                                      icon={
                                        checkLiked(detailReviewModal.data)
                                          ? heartBlue
                                          : heartGray
                                      }
                                      iconHover={heartBlue}
                                      onClick={() => {
                                        checkLiked(detailReviewModal.data)
                                          ? handlePostDisLike(
                                            `rating-${detailReviewModal.data.id}`,
                                            {
                                              type: LIKE_TYPE.RATING,
                                              customer_id: customerId,
                                              id_like: detailReviewModal.data.id,
                                            },
                                            true,
                                          )
                                          : handlePostLike(
                                            `rating-${detailReviewModal.data.id}`,
                                            {
                                              type: LIKE_TYPE.RATING,
                                              customer_id: customerId,
                                              id_like: detailReviewModal.data.id,
                                            },
                                            true,
                                          );
                                      }}
                                    >
                                      {" "}
                                      {detailReviewModal.data.total_likes &&
                                        detailReviewModal.data.total_likes > 0
                                        ? detailReviewModal.data.total_likes
                                        : ""}{" "}
                                      {checkLiked(detailReviewModal.data)
                                        ? "Bỏ thích"
                                        : "Thích"}
                                    </ReplyLove>
                                  )}
                                  <ReplyDivider>|</ReplyDivider>
                                  {detailReviewModal.data &&
                                    detailReviewModal.data.created_at && (
                                      <ReplyDuration>
                                        {getTimeAgo(detailReviewModal.data.created_at)}
                                      </ReplyDuration>
                                    )}
                                </ClientCommentReviewStatusBar>
                              </ActionAndDatingBlock>

                              {detailReviewModal.data.rating_comments && (
                                <CommentBlock>
                                  {detailReviewModal.data.rating_comments.map(
                                    ratingComment => {
                                      const liked =
                                        ratingComment.rating_comment_likes &&
                                        ratingComment.rating_comment_likes.filter(
                                          item =>
                                            item.rating_comment_id === ratingComment.id &&
                                            item.customer_id === customerId,
                                        ).length > 0;
                                      return (
                                        <ClientCommentReviewItem>
                                          <RatingInformationDetailModalTitle>
                                            {ratingComment.user === "admin"
                                              ? "Quản trị viên"
                                              : ratingComment.customer_name}
                                            &nbsp;
                                            <VerifyBuyAtDaikinEShop
                                              icon={
                                                ratingComment.user === "admin"
                                                  ? checkCircleOutlineBlue
                                                  : checkCircleOutlineGreen
                                              }
                                              isAdmin={ratingComment.user === "admin"}
                                            >
                                              {ratingComment.user === "admin"
                                                ? "QTV"
                                                : "Khách"}
                                            </VerifyBuyAtDaikinEShop>
                                          </RatingInformationDetailModalTitle>
                                          <ClientCommentReviewContent>
                                            <span>{ratingComment.comment || ""}</span>
                                          </ClientCommentReviewContent>
                                          <ClientCommentReviewStatusBar>
                                            <ReplyLove
                                              actived={ratingComment.total_likes}
                                              icon={liked ? heartBlue : heartGray}
                                              iconHover={heartBlue}
                                              onClick={() => {
                                                liked
                                                  ? handlePostDisLike(
                                                    `comment-${ratingComment.id}`,
                                                    {
                                                      type: LIKE_TYPE.COMMENT,
                                                      customer_id: customerId,
                                                      id_like: ratingComment.id,
                                                      rating_id:
                                                        ratingComment.rating_id,
                                                    },
                                                    true,
                                                  )
                                                  : handlePostLike(
                                                    `comment-${ratingComment.id}`,
                                                    {
                                                      type: LIKE_TYPE.COMMENT,
                                                      customer_id: customerId,
                                                      id_like: ratingComment.id,
                                                      rating_id:
                                                        ratingComment.rating_id,
                                                    },
                                                    true,
                                                  );
                                              }}
                                            >
                                              {" "}
                                              {processingLikePostLoading.id ===
                                                `comment-${ratingComment.id}` &&
                                                processingLikePostLoading.onload ? (
                                                <Icon iconName="small-loading" />
                                              ) : ratingComment.total_likes &&
                                                ratingComment.total_likes > 0 ? (
                                                ratingComment.total_likes
                                              ) : (
                                                ""
                                              )}{" "}
                                              {liked ? "Bỏ thích" : "Thích"}
                                            </ReplyLove>
                                            <ReplyDivider>|</ReplyDivider>
                                            <ReplyDuration>
                                              {getTimeAgo(ratingComment.updated_at)}
                                            </ReplyDuration>
                                          </ClientCommentReviewStatusBar>
                                        </ClientCommentReviewItem>
                                      );
                                    },
                                  )}
                                </CommentBlock>
                              )}
                            </ModalBodyInner>
                          </ModalBody>
                        </CustomerListReviewModal>
                      )}

                    {
                      // Show Comment Popup
                    }
                    <Modal
                      isOpen={showCommentPopUp.status}
                      onCloseRequest={() =>
                        setShowCommentPopUp({
                          ratingId: -1,
                          status: false,
                        })
                      }
                      resetModal
                    >
                      <ModalHeader
                        onCloseRequest={() =>
                          setShowCommentPopUp({
                            ratingId: -1,
                            status: false,
                          })
                        }
                      >
                        <Text size="lg" weight="bold" modifiers={["uppercase", "center"]}>
                          Nhập thông tin để trả lời
                        </Text>
                      </ModalHeader>
                      <ModalBody>
                        <RatingCommentForm
                          ratingId={showCommentPopUp.ratingId}
                          onSubmitComment={onSubmitCommentForm}
                          onLogout={onLogout}
                        />
                      </ModalBody>
                    </Modal>

                    {lightboxRatingItem && lightBoxRatingItemData && lightBoxRatingItemTypes && (
                      <FsLightbox
                        onClose={() => {
                          setDataLightbox(undefined);
                          setLightboxRatingItem({
                            toggler: false,
                            activeSlide: 1,
                          });
                          setLightBoxRatingItemTypes(undefined);
                          setLightBoxRatingItemData(undefined);
                        }}
                        toggler={lightboxRatingItem.toggler}
                        sources={lightBoxRatingItemData}
                        slide={lightboxRatingItem.activeSlide}
                        types={lightBoxRatingItemTypes}
                      />
                    )}
                  </>
                )}

                {
                  // Bài viết liên quan
                }
                {step12 && step12.news.length > 0 && (
                  <Section space="space-xs-b" className="daikin-news section-pt">
                    <Grid>
                      <GridRow>
                        <GridCol>
                          <div className="titleSection">
                            <Heading modifiers={["uppercase"]}>
                              Bài viết liên quan
                            </Heading>
                          </div>
                        </GridCol>
                        <GridCol>
                          {
                            <Carousel
                              pagination
                              breakpoints={PRODUCT_DETAIL(3)}
                              id={`product-detail-${CAROUSEL_IDS.RELATED_ACTICLE}`}
                            >
                              {step12 &&
                                step12.news.map(item => (
                                  <SwiperSlide key={item.id}>
                                    <CarouselItem>
                                      <Article
                                        imgSrc={`${BASE_URL}${item.thumbnail}`}
                                        category="Chọn máy lạnh phù hợp"
                                        title={item.newsTranslations[0].title}
                                        slug={item.newsTranslations[0].slug}
                                        description={
                                          item.newsTranslations[0].description
                                        }
                                        modifiers={["small"]}
                                      />
                                    </CarouselItem>
                                  </SwiperSlide>
                                ))}
                            </Carousel>
                          }
                        </GridCol>
                      </GridRow>
                    </Grid>
                  </Section>
                )}
              </>
            )}
          </LazyLoad>

          {compareList.length > 0 && (
            <div onClick={goToCompare}>
              <CompareBlock
                topPosition={heroNavPosition}
                count={compareList.length}
              />
            </div>
          )}
        </div>

        <Modal isOpen={notify.status} onCloseRequest={onCloseModal} resetModal>
          <ModalBody>
            {typeof notify.message === "string" ? (
              <Text modifiers={["center"]}>{notify.message}</Text>
            ) : (
              notify.message.map(message => (
                <Text modifiers={["center"]}>{notify.message}</Text>
              ))
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={onCloseModal}
              variant={notify.error ? "danger" : "primary"}
              size="small"
            >
              Đóng
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={toggleInfoBuyingForm} resetModal>
          <ModalHeader onCloseRequest={() => setToggleInfoBuyingForm(false)}>
            <Text size="lg" weight="bold" modifiers={["uppercase", "center"]}>
              thông tin mua hàng
            </Text>
            <Text modifiers={["center", "gray"]}>
              Xin quý khách vui lòng để lại thông tin để chúng tôi liên hệ tư vấn
            </Text>
          </ModalHeader>
          <ModalBody>
            <InfoBuyingForm
              productId={step1 && step1.id}
              onSubmitInfoBuyingForm={onSubmitInfoBuyingForm}
            />
          </ModalBody>
        </Modal>
      </>
    )
  };

  const cateSlug = useMemo(() => step1 && `/danh-muc/${step1?.product_type_id === 3
    ? "loai-2-dan-roi"
    : step1?.product_type_id === 1
      ? "loai-multi"
      : step1?.product_type_id === 2
        ? "may-loc-khong-khi"
        : "sky-air"
    }`, [step1])
  const cateLabel = useMemo(() => step1 &&
    (step1?.product_type_id === 3 ||
      step1?.product_type_id === 1
      ? "Điều Hòa Dân Dụng"
      : step1?.product_type_id === 2
        ? "Máy Lọc Không Khí"
        : "Điều Hòa Thương Mại"), [step1])

  const breadcrumbItems = useMemo(() => {
    return (
      step1 && cateLabel && cateSlug && (
        <Breadcrumb>
          <BreadcrumbItemLink href="/">Trang Chủ</BreadcrumbItemLink>
          <BreadcrumbItemLink
            href={cateSlug}
          >
            Sản Phẩm&nbsp;
          </BreadcrumbItemLink>
          <BreadcrumbItemLink
            href={cateSlug}
          >
            {cateLabel}
          </BreadcrumbItemLink>
          <BreadcrumbItem>
            {step1 && step1.name}
          </BreadcrumbItem>
        </Breadcrumb>
      )
    )
  }, [cateLabel, cateSlug, step1])

  const reviewModalSwiperConfig = useMemo(() => detailReviewModal?.data?.files && ({
    // Provide Swiper class as props
    Swiper,
    // Add modules you need
    modules: [Navigation],
    navigation: true,
  } as SwiperOptions), [detailReviewModal])
  const reviewModalSwiperItem = useMemo(() => detailReviewModal?.data?.files &&
    detailReviewModal.data.files.map((url: string) =>
      isVideo(url) ? (
        <SwiperSlide>
          <Player src={`${BASE_URL}/${url}`} />
        </SwiperSlide>
      ) : (
        <SwiperSlide>
          <Image
            src={BASE_URL + `/${url}`}
            alt={`Đánh giá chi tiết ${detailReviewModal.data.id}`}
          />
        </SwiperSlide>
      ),
    ), [detailReviewModal])

  if (error) {
    return <RedirectNavigate errors={[{ code: 404 }]} />
  }

  return (
    <Layout className="no-spacing-fixed-bottom new-contract-feature-carousel">
      {loadingDetail && <LoadingState mask />}
      {
        //
      }
      <Head data={metaData} />

      {
        //
      }
      {step1 && breadcrumbItems}

      {
        //
      }
      {productDetailWrap()}
    </Layout>
  );
};

export default ProductDetailPage;
